import { type RefObject, type ReactElement } from 'react';
import Button from '@creditflowresearch/uilib/Button';
import Flex from '@creditflowresearch/uilib/Flex';

import styles from './sidebarSlider.module.scss';

interface ICloseConfirmationProps {
  position: { top: number, left: number },
  title?: string,
  message?: string,
  confirmLabel?: string,
  cancelLabel?: string,
  confirmRef: RefObject<HTMLDivElement | null>,
  onConfirm: () => void,
  onCancel: () => void,
}

const CloseConfirmation = ({
  position,
  title = 'Are you sure?',
  message = 'Closing the panel will discard all selected filters without applying any changes.',
  confirmLabel = 'Close',
  cancelLabel = 'Cancel',
  confirmRef,
  onConfirm,
  onCancel,
}: ICloseConfirmationProps): ReactElement => (
  <div
    ref={ confirmRef }
    className={ styles.confirmation }
    style={ { top: position.top, left: position.left } }
    data-test="sidebarSliderConfirmation"
  >
    <p className={ styles.confirmationTitle }>{ title }</p>
    <p className={ styles.confirmationMessage }>{ message }</p>
    <Flex gap={ 10 }>
      <Button
        variant="solid"
        onClick={ onConfirm }
        dataTest="sidebarSliderConfirmClose"
      >
        { confirmLabel }
      </Button>
      <Button
        className={ styles.confirmationCancelButton }
        variant="text"
        onClick={ onCancel }
        dataTest="sidebarSliderCancelClose"
      >
        { cancelLabel }
      </Button>
    </Flex>
  </div>
);

export { CloseConfirmation };
